<template>
    <div>
        <div class="d-flex" id="wrapper">
            <!-- Sidebar -->
            <SideBar/>
            <!-- /#sidebar-wrapper -->
            <!-- Page Content -->
            <div id="page-content-wrapper">
                <nav style="justify-content:flex-start;" class="navbar navbar-expand-lg navbar-light bg-light border-bottom floating">
                    <div>
                        <button class="btn btn-outline" id="menu-toggle" @click="sidebar"><span class="navbar-toggler-icon"></span>
                        </button>

                        <button style="color: rgba(0,0,0,.5);border-color: rgba(0,0,0,.1);" class="btn btn-outline navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                            <span style="padding-top:0.5em;"><i class="fas fa-user-alt"></i><span class="account-div"></span><i class="fas fa-angle-down"></i></span>
                        </button>
                    </div>
                    <div class="d-flex">
                        <!-- <i class="fas fa-home text-muted hover-cursor" @click="toPage('/dashboard')"></i> -->
                        <p class="text-muted mb-0 hover-cursor link">&nbsp;Warehouse</p>
                        <p class="text-muted mb-0 hover-cursor link">&nbsp;/&nbsp;Inventory Product</p>
                        <p class="text-primary mb-0 hover-cursor" v-if="titlePage == 'Edit'">&nbsp;/&nbsp;{{ stockCode }}</p>
                        <p class="text-primary mb-0 hover-cursor" v-else>&nbsp;/&nbsp;Add In</p>
                    </div>
                    <div class="collapse navbar-collapse" id="navbarSupportedContent">
                        <ul class="navbar-nav ml-auto mt-2 mt-lg-0">
                            <li class="nav-item dropdown">
                                <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                  {{ admin }}
                                </a>
                                <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdown">
                                    <a class="dropdown-item link" @click="toPage('/password')"> <i class="fas fa-cog"></i><span class="right-dropdown">Change Password</span></a>
                                    <a class="dropdown-item link" @click="handleLogout"><i class="fas fa-sign-out-alt"></i><span class="right-dropdown">Logout</span></a>
                                </div>
                            </li>
                        </ul>
                    </div>
                </nav>
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-md-12 grid-margin stretch-card card-div">
                            <div class="container">
                                <div class="d-flex flex-wrap justify-content-between">
                                    <div class="w-100 mt-3 mb-3">
                                        <h5 class="text-center">Add In Inventory Product</h5> 
                                    </div>
                                    <div class="card w-100">
                                        <div class="card-body">
                                            <div class="row">
                                                <div class="col-6">
                                                    <div class="w-100 d-flex align-items-center">
                                                        <span class="field-label-one"> Source </span>
                                                        <multiselect
                                                            v-model="source"
                                                            :options="sourceOption"
                                                            :allow-empty="false"
                                                            :select-label="''"
                                                            :deselect-label="''"
                                                            placeholder="Select Source"
                                                            :selectedLabel="''"
                                                            :optionHeight="30"
                                                            @input="resetData"
                                                        ></multiselect>
                                                    </div>
                                                    <div class="w-100 d-flex align-items-center mt-2" v-if="source != ''">
                                                        <span class="field-label-one"> Warehouse </span>
                                                        <multiselect
                                                            v-model="warehouse"
                                                            :options="warehouseOption"
                                                            label="warehouseName"
                                                            :allow-empty="false"
                                                            :select-label="''"
                                                            :deselect-label="''"
                                                            placeholder="Select Warehouse"
                                                            track-by="warehouseName"
                                                            :selectedLabel="''"
                                                            :optionHeight="30"
                                                            @input="getProcurementProduct"
                                                        ></multiselect>
                                                    </div>
                                                    <div class="w-100 d-flex align-items-center mt-2" v-if="source == 'Stock Opname'">
                                                        <span class="field-label-one"> Purchase Date </span>
                                                        <input class="form-control text-field" type="date" name="purchaseDate" v-model="purchaseDate">
                                                    </div>
                                                    <div class="w-100 d-flex align-items-center mt-2" v-if="source == 'Stock Opname'">
                                                        <span class="field-label-one"> Price </span>
                                                        <div class="input-group">
                                                            <span class="input-group-addon" style="margin-left: 0px;"> <label class="label-addon-rp">Rp</label></span>
                                                           <money type="text" class="form-control price" name="price" v-bind="money" @keypress="isNumber($event)" v-model="purchasePrice"></money>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-6" v-if="source == 'Stock Opname'">
                                                    <div class="w-100 d-flex align-items-center">
                                                        <span class="field-label-one"> Type </span>
                                                        <multiselect
                                                            v-model="type"
                                                            :options="$getProductType('unit','')"
                                                            label="statusName"
                                                            :allow-empty="false"
                                                            :select-label="''"
                                                            :deselect-label="''"
                                                            placeholder="Select Type"
                                                            track-by="statusName"
                                                            :selectedLabel="''"
                                                            :optionHeight="30"
                                                            @input="resetSelectField('type')"
                                                        ></multiselect>
                                                    </div>
                                                    <div class="w-100 d-flex align-items-center mt-2">
                                                        <span class="field-label-one"> Brand </span>
                                                        <multiselect v-model="brand" :options="brandOption" :allow-empty="false" :select-label="''" deselect-label="" placeholder="Brand" @input="resetSelectField('brand')"></multiselect>
                                                    </div>
                                                    <div class="w-100 d-flex align-items-center mt-2">
                                                        <span class="field-label-one"> Model </span>
                                                        <multiselect v-model="model" :options="modelOption" label="" :allow-empty="false" :select-label="''" deselect-label="" placeholder="Model" @input="resetSelectField('model')"></multiselect>
                                                    </div>
                                                    <div class="w-100 d-flex align-items-center mt-2">
                                                        <span class="field-label-one"> Variant </span>
                                                        <multiselect v-model="catalogSpec" :options="catalogOption" label="specifications" :allow-empty="false" :select-label="''" deselect-label="" placeholder="Variant" track-by="specifications"></multiselect>
                                                    </div>
                                                    <div class="w-100 d-flex align-items-center mt-2">
                                                        <span class="field-label-one"> Condition </span>
                                                        <multiselect v-model="condition" :options="conditionOption" label="conditionName" :allow-empty="false" :select-label="''" deselect-label="" placeholder="Condition" track-by="conditionName"></multiselect>
                                                    </div>
                                                    <div class="w-100 d-flex align-items-center mt-2" v-if="type.status == '1' || type.status == '2'">
                                                        <span class="field-label-one"> Completness </span>
                                                        <multiselect v-model="completeness" :options="completenessOption" label="statusName" :allow-empty="false" :select-label="''" deselect-label="" track-by="statusName" placeholder="Completness" @input="fillData('',source)"></multiselect>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div> 
                                    <table class="table-bordered mt-3 w-100 table table-bordered table-striped table-responsive-sm table-sm mb-0" v-if="source == 'Procurement' && warehouse != ''">
                                        <tbody class="full-width">
                                            <tr>
                                                <th>Product</th>
                                                <th>Supplier</th>
                                                <th>Qty</th>
                                                <th>Checked</th>
                                                <th>Completness</th>
                                                <th>Action</th>
                                            </tr>
                                             <tr v-if="loadingDataProcurement">
                                                <td colspan="6" class="text-center"><img src="~@/assets/images/load-button.gif"></td>
                                            </tr>
                                            <tr v-else-if="dataProductProcurement.length == 0">
                                                <td colspan="6" class="text-center">Data Not Available</td>
                                            </tr>
                                            <tr v-else v-for="(data, index) in dataProductProcurement" :key="`dataProductProcurement-${index}`">
                                                <td>{{ data.productName }} <br> {{ data.specifications }}</td>
                                                <td>{{ data.supplierName }}</td>
                                                <td>{{ data.qty }}</td>
                                                <td>{{ data.checked }}</td>
                                                <td><span v-if="data.typeId == 1 || data.typeId == 2">{{ $getConstantsName('COMPLETENESS',data.completeness) }}</span></td>
                                                <td><span class="link link-blue-underline" @click="fillData(data, source)">Fill data</span></td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <div class="card w-100 mt-3" v-if="dataChoose.length != 0 || (source == 'Stock Opname' && type != '')">
                                        <div class="card-body">
                                            <h5 v-if="source == 'Stock Opname'">Actual Specifications</h5>
                                            <div class="font-weight-bold"> {{ dataChoose.productName }} </div>
                                            <div class="font-weight-bold">{{ dataChoose.specifications }}</div>
                                            <div class="font-weight-bold">{{ dataChoose.supplierName }}</div>
                                            <hr>
                                            <div v-if="dataChoose.typeId == '1' || dataChoose.typeId == '2' || type.status == '1' || type.status == '2'">
                                                <div class="row d-flex align-items-center">
                                                    <div class="col-1" style="max-width: 139px">
                                                        <div class="w-100 d-flex">
                                                            <span class="field-label-one"> Processor </span>
                                                        </div>
                                                    </div>
                                                    <div class="col-11" style="max-width: 87.3%">
                                                        <div class="w-100 d-flex align-items-center">
                                                            <multiselect
                                                                v-model="dataActual['processor']"
                                                                :options="getSkuOption(dataChoose.typeId)"
                                                                label="skuName"
                                                                :allow-empty="false"
                                                                :select-label="''"
                                                                :deselect-label="''"
                                                                placeholder="Select SKU"
                                                                track-by="skuName"
                                                                :selectedLabel="''"
                                                                :optionHeight="30"
                                                                v-if="dataChoose.length != 0"
                                                            ></multiselect>
                                                            <multiselect
                                                                v-model="dataActual['processor']"
                                                                :options="getSkuOption(type.status)"
                                                                label="skuName"
                                                                :allow-empty="false"
                                                                :select-label="''"
                                                                :deselect-label="''"
                                                                placeholder="Select SKU"
                                                                track-by="skuName"
                                                                :selectedLabel="''"
                                                                :optionHeight="30"
                                                                v-else
                                                            ></multiselect>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div v-if="dataActual['ram'].length != 0">
                                                    <div class="row d-flex align-items-center" v-for="(data,index) in dataActual['ram']" :key="`actual-${index}`">
                                                        <div class="col-1" style="max-width: 139px">
                                                            <div class="w-100 d-flex mt-2">
                                                                <span class="field-label ram"> RAM ke-{{index+1}}</span>
                                                            </div>
                                                        </div>
                                                        <div class="col-11" style="max-width: 87.3%">
                                                            <div class="w-100 d-flex align-items-center mt-2">
                                                                <multiselect
                                                                    v-model="dataActual['ram'][index]"
                                                                    :options="getSkuOption(20)"
                                                                    label="skuName"
                                                                    :allow-empty="false"
                                                                    :select-label="''"
                                                                    :deselect-label="''"
                                                                    placeholder="Select SKU"
                                                                    track-by="skuName"
                                                                    :selectedLabel="''"
                                                                    :optionHeight="30"
                                                                ></multiselect>
                                                                <button class="btn btn-primary ml-1 text-field" v-if="index == 0" @click="addData('ram')" data-toggle="tooltip" data-placement="top" title="Add More Ram"><i style="font-size:11px" class="fa">&#xf067;</i></button>
                                                                <button class="btn btn-danger ml-1 text-field" v-if="index > 0" @click="removeData('ram', index)" data-toggle="tooltip" data-placement="top" title="Remove Ram"><i style="font-size:11px; width: 10px" class="fa">&#xf00d;</i></button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div v-if="dataActual['storage'].length != 0 && (dataChoose.completeness == 1 || completeness.status == 1)">
                                                    <div class="row d-flex align-items-center" v-for="(data,index) in dataActual['storage']" :key="`actualStorage-${index}`">
                                                        <div class="col-1" style="max-width: 139px">
                                                            <div class="w-100 d-flex mt-2">
                                                                <span class="field-label storage"> Storage ke-{{index+1}}</span>
                                                            </div>
                                                        </div>
                                                        <div class="col-11" style="max-width: 87.3%">
                                                            <div class="w-100 d-flex align-items-center mt-2">
                                                                <multiselect
                                                                    v-model="dataActual['storage'][index]"
                                                                    :options="getSkuOption('storage')"
                                                                    label="skuName"
                                                                    :allow-empty="false"
                                                                    :select-label="''"
                                                                    :deselect-label="''"
                                                                    placeholder="Select SKU"
                                                                    track-by="skuName"
                                                                    :selectedLabel="''"
                                                                    :optionHeight="30"
                                                                ></multiselect>
                                                                <button class="btn btn-primary ml-1 text-field" v-if="index == 0" @click="addData('storage')" data-toggle="tooltip" data-placement="top" title="Add More Storage"><i style="font-size:11px" class="fa">&#xf067;</i></button>
                                                                <button class="btn btn-danger ml-1 text-field" v-if="index > 0" @click="removeData('storage', index)" data-toggle="tooltip" data-placement="top" title="Remove Storage"><i style="font-size:11px; width: 10px" class="fa">&#xf00d;</i></button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div v-if="dataActual['vga'].length != 0">
                                                    <div class="row d-flex align-items-center" v-for="(data,index) in dataActual['vga']" :key="`actualVga-${index}`">
                                                        <div class="col-1" style="max-width: 139px">
                                                            <div class="w-100 d-flex mt-2">
                                                                <span class="field-label gpu"> GPU ke-{{index+1}}</span>
                                                            </div>
                                                        </div>
                                                        <div class="col-11" style="max-width: 87.3%">
                                                            <div class="w-100 d-flex align-items-center mt-2">
                                                                <multiselect
                                                                    v-model="dataActual['vga'][index]"
                                                                    :options="getSkuOption(23)"
                                                                    label="skuName"
                                                                    :allow-empty="false"
                                                                    :select-label="''"
                                                                    :deselect-label="''"
                                                                    placeholder="Select SKU"
                                                                    track-by="skuName"
                                                                    :selectedLabel="''"
                                                                    :optionHeight="30"
                                                                ></multiselect>
                                                                <button class="btn btn-primary ml-1 text-field" v-if="index == 0" @click="addData('gpu')" data-toggle="tooltip" data-placement="top" title="Add More GPU"><i style="font-size:11px" class="fa">&#xf067;</i></button>
                                                                <button class="btn btn-danger ml-1 text-field" v-if="index > 0" @click="removeData('gpu', index)" data-toggle="tooltip" data-placement="top" title="Remove GPU"><i style="font-size:11px; width: 10px" class="fa">&#xf00d;</i></button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-6">
                                                        <div class="w-100 d-flex align-items-center mt-2" v-if="source == 'Stock Opname'">
                                                            <span class="field-label-one"> Stock Code </span>
                                                            <input type="text" name="stockCode" class="form-control text-field" placeholder="Stock Code" v-model="stockCode" :disabled="autoGenerate">
                                                        </div>
                                                        <div class="w-100 d-flex align-items-center mt-2">
                                                            <span class="field-label-one"> Serial Number </span>
                                                            <input type="text" name="ram" class="form-control text-field" placeholder="Serial Number" v-model="serialNumber">
                                                        </div>
                                                        <div class="w-100 d-flex align-items-center mt-2">
                                                            <span class="field-label-one" style="margin-top: -47px;"> Notes </span>
                                                            <textarea rows="3" class="form-control" style="resize: none;" placeholder="Notes" v-model="notes"></textarea>
                                                        </div>
                                                    </div>
                                                    <div class="col-6" v-if="source == 'Stock Opname'">
                                                        <div class="text-field mt-2" v-if="completeness.status == 1"></div>
                                                        <div class="w-100 d-flex align-items-center mt-3 ml-3">
                                                            <input type="checkbox" class="form-check-input" id="exampleCheck1" v-model="autoGenerate">
                                                            <label class="form-check-label" for="exampleCheck1">Auto Generate</label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div v-else>
                                                <div class="row">
                                                    <div class="col-6">
                                                        <div class="w-100 d-flex align-items-center mt-2" v-if="source == 'Stock Opname'">
                                                            <span class="field-label-one"> Stock Code </span>
                                                            <input type="text" name="stockCode" class="form-control text-field" placeholder="Stock Code" v-model="stockCode" :disabled="autoGenerate">
                                                        </div>
                                                        <div class="w-100 d-flex align-items-center mt-2" v-if="dataChoose.typeId == '3' || type.status == 3">
                                                            <span class="field-label-one"> Serial Number </span>
                                                            <input type="text" name="ram" class="form-control text-field" placeholder="Serial Number" v-model="serialNumber">
                                                        </div>
                                                        <div class="w-100 d-flex align-items-center mt-2" v-if="dataChoose.typeId == '5' || dataChoose.typeId == '6' || type.status == '5' || type.status == '6'">
                                                            <span class="field-label-one"> IMEI </span>
                                                            <input type="text" name="ram" class="form-control text-field" placeholder="IMEI" v-model="serialNumber">
                                                        </div>
                                                        <div class="w-100 d-flex align-items-center mt-2">
                                                            <span class="field-label-one" style="margin-top: -47px;"> Notes </span>
                                                            <textarea rows="3" class="form-control" style="resize: none;" placeholder="Notes" v-model="notes"></textarea>
                                                        </div>
                                                    </div>
                                                    <div class="col-6">
                                                        <div class="w-100 d-flex align-items-center mt-3" v-if="source == 'Stock Opname'">
                                                            <input type="checkbox" class="form-check-input" id="exampleCheck1" v-model="autoGenerate">
                                                            <label class="form-check-label" for="exampleCheck1">Auto Generate</label>
                                                        </div>
                                                    </div>
                                                </div>  
                                            </div>
                                        </div>
                                    </div>
                                    <!-- <table class="fixed_header table-bordered mt-3 w-100 table table-bordered table-striped table-responsive-sm" v-if="titlePage == 'Edit'">
                                        <tbody class="full-width">
                                            <tr>
                                                <th style="min-width: 150px;">Date</th>
                                                <th style="min-width: 500px;">Action</th>
                                                <th>Executor</th>
                                            </tr>
                                            <tr v-if="[1,2,3].length == 0">
                                                <td colspan="3">Tidak ada Log</td>
                                            </tr>
                                            <tr v-else v-for="data in [1,2,3]">
                                                <td>0</td>
                                                <td>0</td>
                                                <td>0</td>
                                            </tr>
                                        </tbody>
                                    </table> -->
                                </div>
                                <div class="d-flex justify-content-end mt-2">
                                    <button class="btn btn-sm btn-primary ml-1">Cancel</button>
                                    <button class="btn btn-sm btn-primary ml-1" @click="validationField(source)">Save</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- /#page-content-wrapper -->
            <!-- Modal Save-->
            <div class="modal fade" id="modalSave" role="dialog">
                <div class="modal-dialog modal-dialog-centered">
                    <!-- Modal content-->
                    <div class="modal-content">
                        <div class="modal-header">
                            <div class="change-title">
                                <h4 class="modal-title">Save Product</h4>
                            </div>
                            <button type="button" class="close" data-dismiss="modal">&times;</button>
                        </div>
                        <div class="modal-body">
                            <p>Are you sure to save product?</p>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-danger btn-sm" data-dismiss="modal">Cancel</button>
                            <button type="button" class="btn btn-primary btn-sm" :disabled="loadingButtonSave" @click="submitAdd"><img src="~@/assets/images/2.gif" style="height: 18px;" v-if="loadingButtonSave">Save</button>
                        </div>
                    </div>
                </div>
            </div>
            <!-- endModal -->
        </div>
    </div>
</template>

<script>
import swal from 'sweetalert'
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import CONSTANT from '../constPlugin';
import {Money} from 'v-money'
import SideBar from '../SideBar'
export default {
    name: 'ProductAddPage',
    components: {
        SideBar,
        Multiselect,
        Money
    },
    data() {
        return {
            spaceRegex: /[\u00A0\uFEFF\u202F]/g,
            admin: "",
            permission: [],
            viewDashboard: false,
            viewInventoryProduct: false,
            loadingButtonSave: false,
            loadingLog:false,
            type:[],
            brand:'',
            brandOption:[],
            model:'',
            modelOption:[],
            catalogSpec:[],
            catalogOption:[],
            status:[],
            statusOption:[],
            lessee:'',
            lessor:[],
            lessorOption:[],
            lessorPoint:[],
            lessorPointOption:[],
            purchaseDate:'',
            purchasePrice:'0',
            stockCode:'',
            serialNumber:'',
            notes:'',
            detailProduct:[],
            money: {
                decimal: ',',
                thousands: '.',
                prefix: '',
                suffix: '',
                precision: 0,
                masked: false
            },
            titlePage:'',
            sourceOption:['Procurement', 'Stock Opname'],
            source:'',
            dataActual:[],
            totalData:0,
            dataLog:[],
            warehouseOption:[],
            warehouse:[],
            dataProductProcurement:[],
            loadingDataProcurement : false,
            dataChoose : [],
            allSKU : [],
            completeness :'',
            completenessOption : [],
            autoGenerate: false,
            condition:{
                condition:0,
                conditionName:'Available'
            },
            conditionOption:[
            {
                condition:0,
                conditionName:'Available'
            },
            {
                condition:1,
                conditionName:'Broken'
            }
            ],
        }
    },
    methods: {
        getProductBrand(type) {
            this.$http.post(process.env.GET_ORDER_PRODUCT_BRAND, {
                    productType: type
                }, {
                    headers: {
                        'Asani-Token': localStorage.getItem('jwt')
                    }
                })
                .then(response => {
                    if (response.data.status !== 200) {
                        swal("Sorry", response.data.message, "error", {
                            button: "Ok",
                        })

                    } else {
                        this.brandOption = []
                        for (var i = 0; i < Object.values(response.data.content.productBrand).length; i++) {
                            this.brandOption.push(Object.values(response.data.content.productBrand)[i])
                        }
                        // this.getOrderProductModel()
                    }
                })
                .catch(error => {
                    swal("Sorry", error.response.data.message, "error", {
                        button: "Ok",
                    }).then(v => {
                        if(error.response.data.status == 401) {
                        this.handleLogout()
                        }
                    })
                })
        },
        getCatalogSpec(type, brand, model){
            this.$http.post(process.env.GET_CATALOG_SPEC,{
                type: type,
                brand: brand !== null ? brand.replace(this.spaceRegex, ' ') : brand,
                model: model !== null ? model.replace(this.spaceRegex, ' ') : model
              },{
                headers: {'Asani-Token':localStorage.getItem('jwt')}
              })
              .then(response => {
                if (response.data.status == 400) {
                    swal("Sorry", response.data.message, "error", {
                            button: "Ok",
                        })

                } else{
                    this.catalogOption = response.data.content
                }
              })
              .catch(error => {
                swal("Sorry", error.response.data.message, "error", {
                    button: "Ok",
                }).then(v => {
                    if(error.response.data.status == 401) {
                        this.handleLogout()
                    }
                })
              })
        },
        getProductModel(type, brand){
            this.$http.post(process.env.GET_PRODUCT_MODEL,{
                type: type,
                brand: brand !== null ? brand.replace(this.spaceRegex, ' ') : brand
              },{
                headers: {'Asani-Token':localStorage.getItem('jwt')}
              })
              .then(response => {
                if (response.data.status == 400) {
                    swal("Sorry", response.data.message, "error", {
                            button: "Ok",
                        })

                }else{
                    this.modelOption = response.data.content
                }
              })
              .catch(error => {
                swal("Sorry", error.response.data.message, "error", {
                    button: "Ok",
                }).then(v => {
                    if(error.response.data.status == 401) {
                        this.handleLogout()
                    }
                })
              })
        },
        resetSelectField(fieldSelect){
            if (fieldSelect == 'type') {
                this.brand = ''
                this.model = ''
                this.catalogSpec = []
                if (this.source == 'Stock Opname' && this.type != '') {
                    this.getProductBrand(this.type.status)                    
                }
                if (this.type.status == '5' || this.type.status == '6') {
                    this.dataActual = {
                        processor : '',
                        ram : '',
                        storage : '',
                        screen : '',
                        rearCamera: '',
                        frontCamera: '',
                        battery: ''
                    }
                }else if (this.type.status == '3') {
                    this.dataActual = {
                        displaySize : '',
                        displayType : '',
                        portVga : '',
                        portHdmi : '',
                        portDvi : '',
                    }
                }
            }else if (fieldSelect == 'brand') {
                this.model = ''
                this.catalogSpec = []
                this.getProductModel(this.type.status, this.brand)
            }else if (fieldSelect == 'model') {
                this.catalogSpec = []
                this.getCatalogSpec(this.type.status, this.brand, this.model)
            }
        },
        getSkuOption(type){
            let sku = []
            if (type == '1') {
                type = 1
            }else if (type == '2') {
                type = 18
            }
            if (type == 'storage') {
                for (var i = 0; i < this.allSKU.length; i++) {
                    if (this.allSKU[i].typeId == 21 || this.allSKU[i].typeId == 22 || this.allSKU[i].typeId == 24) {
                        sku.push({
                            componentId : this.allSKU[i].componentId,
                            skuName : this.allSKU[i].skuName,
                            componentName : this.allSKU[i].componentName,
                            sku : this.allSKU[i].sku,
                            typeId : this.allSKU[i].typeId,
                        })
                    }
                }
            }else{
                for (var i = 0; i < this.allSKU.length; i++) {
                    if (this.allSKU[i].typeId == type) {
                        sku.push({
                            componentId : this.allSKU[i].componentId,
                            skuName : this.allSKU[i].skuName,
                            componentName : this.allSKU[i].componentName,
                            sku : this.allSKU[i].sku,
                            typeId : this.allSKU[i].typeId,
                        })
                    }
                }
            }
            return sku
        },
        resetData(){
            this.dataChoose = []
            this.dataProductProcurement = []
            this.purchaseDate = ''
            this.supplier = []
            this.resetSelectField('type')
            this.type = []
        },
        getComponentSKU(dataType){
            this.$http.post(process.env.GET_COMPONENT_SKU,{
                dataType : dataType,
            },{
                headers: {'Asani-Token':localStorage.getItem('jwt')}
            })
            .then(response => {
                if (response.data.status == 400) {
                    swal("Sorry", response.data.message, "error", {
                            button: "Ok",
                        })

                }else if (response.data.status == 200) {
                    this.allSKU = response.data.content
                    // this.loadingDataProcurement = false
                }
            })
            .catch(error => {
                // self.loadingDataProcurement = false
                alert('Error With API please try again !')
                swal("Sorry", error.response.data.message, "error", {
                    button: "Ok",
                }).then(v => {
                    if(error.response.data.status == 401) {
                        this.handleLogout()
                    }
                })
            })
        },
        fillData(data, source){
            if (source == 'Procurement') {
                this.dataChoose = data
                var typeId = this.dataChoose.typeId 
                var completeness = this.dataChoose.completeness
            }else{
                var typeId = this.type.status 
                var completeness = this.completeness.status
                this.stockCode = ''
            }
            this.notes = ''
            this.serialNumber = ''
            if ((typeId == 1 || typeId == 2) && completeness == 0) {
                this.dataActual = {
                    processor : '',
                    ram : [''],
                    vga : [''],
                }
                if (typeId == 1) {
                    var dataType =[1,20,23]
                }else{
                    var dataType =[18,20,23]                    
                }
            }else if ((typeId == 1 || typeId == 2) && completeness == 1) {
                this.dataActual = {
                    processor : '',
                    storage :[''],
                    ram : [''],
                    vga : ['']
                }
                if (typeId == 1) {
                    var dataType =[1,20,21,22,23]
                }else{
                    var dataType =[18,20,21,22,23]                    
                }
            }
            if (source == 'Procurement' && (typeId == 1 || typeId == 2)) {
                this.getComponentSKU(dataType)
            }else if (source != 'Procurement'){
                this.getComponentSKU(dataType)
            }
        },
        getProcurementProduct(){
            var self = this
            this.dataChoose = []
            this.loadingDataProcurement = true
            this.$http.post(process.env.GET_PRODUCT_PROCUREMENT_WAREHOUSE,{
                warehouseId:this.warehouse.warehouseId,
            },{
                headers: {'Asani-Token':localStorage.getItem('jwt')}
            })
            .then(response => {
                if (response.data.status == 400) {
                    swal("Sorry", response.data.message, "error", {
                            button: "Ok",
                        })

                }else if (response.data.status == 200) {
                    this.dataProductProcurement = response.data.content
                    this.loadingDataProcurement = false
                }
            })
            .catch(error => {
                self.loadingDataProcurement = false
                alert('Error With API please try again !')
                swal("Sorry", error.response.data.message, "error", {
                    button: "Ok",
                }).then(v => {
                    if(error.response.data.status == 401) {
                        this.handleLogout()
                    }
                })
            })
        },
        toInventoryProductPage(){
          this.$router.push({
                path: '/inventory/product',
                query: {
                    warehouseId: 'All',
                    warehouseName: 'All',
                    productId: '',
                    type: 'All',
                    name:'',
                    criteria:0,
                    page: 1,
                    itemPerPage: 10,
                }
            })
        },
        addData(variableName){
            if (variableName == 'ram') {
                this.dataActual['ram'].push('')
            }else if (variableName == 'storage') {
                this.dataActual['storage'].push('')
            }else if (variableName == 'gpu') {
                this.dataActual['vga'].push('')
            }
        },
        removeData(variableName, index){
            if (variableName == 'ram') {
                this.dataActual['ram'].splice(index,1)
            }else if (variableName == 'storage') {
                this.dataActual['storage'].splice(index,1)
            }else if (variableName == 'gpu') {
                this.dataActual['vga'].splice(index,1)
            }
        },
        validationArray(field){
            let result = true
            if (field == 'ram') {
                for (var i = 0; i < this.dataActual['ram'].length; i++) {
                    if(this.dataActual['ram'][i] == ''){
                        result = false
                    }
                }
            }else if (field == 'storage' && (this.dataChoose.completeness == 1 || this.completeness.status == 1)) {
                for (var i = 0; i < this.dataActual['storage'].length; i++) {
                    if(this.dataActual['storage'][i] == ''){
                        result = false
                    }
                }
            }else if (field == 'gpu') {
                for (var i = 0; i < this.dataActual['vga'].length; i++) {
                    if(this.dataActual['vga'][i] == ''){
                        result = false
                    }
                }
            }
            return result
        },
        validationField(source) {
            if (source == 'Procurement') {
                if (this.dataChoose.typeId != '1' && this.dataChoose.typeId != '2') {
                    if (this.serialNumber == '' && this.dataChoose.typeId != '5' && this.dataChoose.typeId != '6') {
                        swal("Sorry", "Serial number must be fill", "error", {
                            button: "Ok",
                        })
                    }else if (this.serialNumber == '' && (this.dataChoose.typeId == '5' || this.dataChoose.typeId == '6')) {
                        swal("Sorry", "IMEI must be fill", "error", {
                            button: "Ok",
                        })
                    }else{
                        this.openModal('Save')
                    }
                }else{
                    if (this.dataActual['processor'] == '') {
                        swal("Sorry", "Processor must be fill", "error", {
                            button: "Ok",
                        })
                    }else if (this.validationArray('ram') == false) {
                        swal("Sorry", "RAM must be fill", "error", {
                            button: "Ok",
                        })
                    }else if (this.validationArray('storage') == false) {
                        swal("Sorry", "storage must be fill", "error", {
                            button: "Ok",
                        })
                    }else if (this.validationArray('gpu') == false) {
                        swal("Sorry", "GPU must be fill", "error", {
                            button: "Ok",
                        })
                    }else if (this.serialNumber == '') {
                        swal("Sorry", "Serial number must be fill", "error", {
                            button: "Ok",
                        })
                    } else {
                        this.openModal('Save')
                    }
                }
            }else{
                if (this.warehouse == '') {
                    swal("Sorry", "Warehouse must be choose", "error", {
                        button: "Ok",
                    })
                }else if (this.purchaseDate == '' || this.purchaseDate == null) {
                    swal("Sorry", "Purchase Date must be choose", "error", {
                        button: "Ok",
                    })
                }else if (this.purchasePrice === '') {
                    swal("Sorry", "Purchase Price must be fill", "error", {
                        button: "Ok",
                    })
                }else if (this.type == '') {
                    swal("Sorry", "Type must be choose", "error", {
                        button: "Ok",
                    })
                }else if (this.brand == '') {
                    swal("Sorry", "Brand must be choose", "error", {
                        button: "Ok",
                    })
                }else if (this.model == '') {
                    swal("Sorry", "Model must be choose", "error", {
                        button: "Ok",
                    })
                }else if (this.catalogSpec == '') {
                    swal("Sorry", "Variant must be choose", "error", {
                        button: "Ok",
                    })
                }else if (this.condition == '') {
                    swal("Sorry", "Condition must be choose", "error", {
                        button: "Ok",
                    })
                }else if (this.completeness == '' && (this.type.status == 1 || this.type.status == 2)) {
                    swal("Sorry", "Completness must be choose", "error", {
                        button: "Ok",
                    })
                }else if (this.type.status != '1' && this.type.status != '2') {
                    if (this.serialNumber == '' && this.type.status != '5' && this.type.status != '6') {
                        swal("Sorry", "Serial number must be fill", "error", {
                            button: "Ok",
                        })
                    }else if (this.serialNumber == '' && (this.type.status == '5' || this.type.status == '6')) {
                        swal("Sorry", "IMEI must be fill", "error", {
                            button: "Ok",
                        })
                    }else{
                        this.openModal('Save')
                    }
                }else{
                    if (this.dataActual['processor'] == '') {
                        swal("Sorry", "Processor must be fill", "error", {
                            button: "Ok",
                        })
                    }else if (this.validationArray('ram') == false) {
                        swal("Sorry", "RAM must be fill", "error", {
                            button: "Ok",
                        })
                    }else if (this.validationArray('storage') == false) {
                        swal("Sorry", "storage must be fill", "error", {
                            button: "Ok",
                        })
                    }else if (this.validationArray('gpu') == false) {
                        swal("Sorry", "GPU must be fill", "error", {
                            button: "Ok",
                        })
                    }else if (this.stockCode == '' && this.autoGenerate == false) {
                        swal("Sorry", "Stock Code must be fill", "error", {
                            button: "Ok",
                        })
                    }else if (this.serialNumber == '') {
                        swal("Sorry", "Serial number must be fill", "error", {
                            button: "Ok",
                        })
                    } else {
                        this.openModal('Save')
                    }
                }
            }
        },
        openModal(x) {
            $("#modal" + x).modal('show')
        },
        toPage(e) {
            this.$router.push(e)
        },
        async handleLogout() {
      try {
        const response = await this.$http.post(process.env.LOGOUT, {}, {
          headers: {
            'Asani-Token': localStorage.getItem('jwt')
          }
        })
        if (response.data.status !== 200) {
          swal("Sorry", response.data.message, "error", {
            button: "Ok",
          })
          return
        }

      } catch (error) {
        if(error.response.data.status != 401) {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          })
          return
        }
      }
            localStorage.removeItem('jwt')
            localStorage.removeItem('admin_name')
            localStorage.removeItem('roles')
            localStorage.removeItem('user_email')
            localStorage.removeItem('admin_id')
            localStorage.removeItem('changeCatalogPermission')
            this.$router.push('/')
        },
        cekLogin() {
            if (localStorage.getItem('jwt') == null) {
                this.$router.push('/')
            }
        },
        cekPermission() {
            this.permission = localStorage.getItem('roles').replace(/"/g, "").replace("[", "").replace("]", "").split(",")
            for (var i = 0; i < this.permission.length; i++) {
                if (this.permission[i] == "1") {
                    this.viewDashboard = true
                }
                if (this.permission[i] == "2.1") {
                    this.viewOrder = true
                }
                if (this.permission[i] == "2.2") {
                    this.editOrder = true
                }
                if (this.permission[i] == '3.1') {
                    this.viewReturn = true
                }
                if (this.permission[i] == '3.2') {
                    this.editReturn = true
                }
                if (this.permission[i] == '4.1') {
                    this.viewProduct = true
                }
                if (this.permission[i] == '4.2') {
                    this.editProduct = true
                }
                if (this.permission[i] == '5.1') {
                    this.viewPairing = true
                }
                if (this.permission[i] == '5.2') {
                    this.editPairing = true
                }
                if (this.permission[i] == '6') {
                    this.viewReconcile = true
                }
                if (this.permission[i] == '7.1') {
                    this.viewResolution = true
                }
                if (this.permission[i] == '7.2') {
                    this.editResolution = true
                }
                if (this.permission[i] == '8.1') {
                    this.viewLessor = true
                }
                if (this.permission[i] == '8.2') {
                    this.editLessor = true
                }
                if (this.permission[i] == '9.1') {
                    this.viewLessee = true
                }
                if (this.permission[i] == '9.2') {
                    this.editLessee = true
                }
                if (this.permission[i] == '10') {
                    this.viewEmployee = true
                }
            }
            if (this.editProduct == false) {
                this.$router.push('/')
            }
        },
        sidebar() {
            $("#wrapper").toggleClass("toggled");
        },
        isNumber: function(evt) {
            evt = (evt) ? evt : window.event;
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                evt.preventDefault();;
            } else {
                return true;
            }
        },
        getData() {
            this.$http.get(process.env.GET_ALL_WAREHOUSE,{
                headers: {'Asani-Token':localStorage.getItem('jwt')}
            })
            .then(response => {
                if (response.data.status == 400) {
                    swal("Sorry", response.data.message, "error", {
                            button: "Ok",
                        })

                } else{
                    this.warehouseOption = response.data.content
                }
            })
            .catch(error => {
                swal("Sorry", error.response.data.message, "error", {
                    button: "Ok",
                }).then(v => {
                    if(error.response.data.status == 401) {
                        this.handleLogout()
                    }
                })
            })
            this.completenessOption = []
            for (var i = 0; i < CONSTANT.COMPLETENESS.length; i++) {
                this.completenessOption.push(CONSTANT.COMPLETENESS[i])
            }
        },
        resetFieldProcurement(){
            
        },
        submitAdd(){
            var self = this
            let data = {}
            this.loadingButtonSave = true
            let uniqueId = null
            if (this.source == 'Procurement') {
                uniqueId = this.dataChoose.pdId
                if (this.dataChoose.typeId == '1' || this.dataChoose.typeId == '2') {
                    data = {
                        actualSpec : this.dataActual,
                        warehouseId : this.warehouse.warehouseId,
                        serialNumber : this.serialNumber,
                        notes : this.notes,
                        typeId : this.dataChoose.typeId
                    }
                }else{
                    data = {
                        // productId : this.catalogSpec.productId,
                        // status : this.status.status,
                        // lessorPointId : this.lessorPoint.lessorPointId,
                        // purchaseDate : this.purchaseDate,
                        // purchasePrice : this.purchasePrice,
                        // actualSpec : this.dataActual,
                        warehouseId : this.warehouse.warehouseId,
                        serialNumber : this.serialNumber,
                        notes : this.notes,
                        typeId : this.dataChoose.typeId
                    }
                }    
            }else{
                uniqueId = this.catalogSpec.productId
                if (this.type.status == '1' || this.type.status == '2') {
                    data = {
                        purchaseDate : this.purchaseDate,
                        purchasePrice : this.purchasePrice,
                        condition : this.condition.condition,
                        completeness : this.completeness.status,
                        actualSpec : this.dataActual,
                        warehouseId : this.warehouse.warehouseId,
                        serialNumber : this.serialNumber,
                        notes : this.notes,
                        typeId : this.type.status,
                        stockCode : this.stockCode,
                        autoGenerate : this.autoGenerate
                    }
                }else{
                    data = {
                        // productId : this.catalogSpec.productId,
                        // status : this.status.status,
                        // lessorPointId : this.lessorPoint.lessorPointId,
                        purchaseDate : this.purchaseDate,
                        purchasePrice : this.purchasePrice,
                        condition : this.condition.condition,
                        warehouseId : this.warehouse.warehouseId,
                        serialNumber : this.serialNumber,
                        notes : this.notes,
                        typeId : this.type.status,
                        stockCode : this.stockCode,
                        autoGenerate : this.autoGenerate
                    }
                }
            }
            
            this.$http.post(process.env.INVENTORY_PRODUCT_ADD_IN,{
                  type:this.source,
                  uniqueId: uniqueId,
                  data: data
              },{
                headers: {'Asani-Token':localStorage.getItem('jwt')}
              })
              .then(response => {
                if (response.data.status == 400) {
                    swal("Sorry", response.data.message, "error", {
                            button: "Ok",
                        })

                }else if (response.data.status == 200) {
                    $("#modalSave").modal('hide')
                    if (response.data.content.exitPage) {
                       swal("Success", response.data.message, "success", {
                            button: "Close",
                        }).then((value) => {
                            this.toInventoryProductPage()
                        }) 
                    }else{
                        swal("Success", response.data.message, "success", {
                            button: "Close",
                        })
                        this.getProcurementProduct()
                    }
                    this.loadingButtonSave = false
                }else if (response.data.status == 201) {
                    swal("Sorry", response.data.message, "error", {
                        button: "Ok",
                    });
                    this.loadingButtonSave = false
                    $("#modalSave").modal('hide')
                }
              })
              .catch(error => {
                self.loadingButtonSave = false
                alert('Error With API')
                swal("Sorry", error.response.data.message, "error", {
                    button: "Ok",
                }).then(v => {
                    if(error.response.data.status == 401) {
                        this.handleLogout()
                    }
                })
              })
        }
    },
    created() {
        this.getData()
        this.admin = localStorage.getItem('admin_name')
        this.adminId = localStorage.getItem('admin_id')
        this.cekLogin()
        this.cekPermission()
    }
} 
</script>

    <!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .link-blue-underline{
        color: #2797FB;
        font-style: italic;
        text-decoration: underline;
    }
    .gpu-field{
        width: 415px;
    }
    .field-label.gpu{
        width: 256px;
    }
    .gpu-size{
        width: 230px;
    }
    .ram-type{
        width: 156px;
    }
    .text-field{
        height: 42.2px;
    }
    .price{
        height: 42.2px;
    }
    .field-label{
        width: 188px;
    }
    .field-label.ram{
        width: 345px;
    }
    .field-label.storage{
        width: 345px;
    }
    .storage-type{
        width: 339px;
    }
    .field-label-one{
        width: 196px;
    }
    .field-label-one.sku{
        width: 60px;
    }
    .field-label.sku{
        width: 66px;
    }
    .input-group-addon {
        padding: 7px 12px;
        font-size: 14px;
        font-weight: 400;
        line-height: 1;
        color: #555;
        text-align: center;
        background-color: #eee;
        border: 1px solid #ccc;
        border-radius: 4px 0px 0px 4px;
        border-right: none;
        margin: 0px 0px 0px 10px;
        height: 42.2px;
    }
</style>


// WEBPACK FOOTER //
// src/components/Warehouse/InventoryProductAddInPage.vue